let APIInterceptorFactory = function($rootScope, $injector) {
    let service = this;

    service.request = function(config) {
        let User = $injector.get('User');
        let authData = User.getToken();
        let access_token = authData ? authData : null;
        if (access_token) {
            config.headers.authorization = access_token;
        }

        return config;
    };

    service.responseError = function(response) {
        if (response.status === 401) {
            //$rootScope.$broadcast('unauthorized');
        }
        return response;
    };
}

APIInterceptorFactory.$inject = ['$rootScope', '$injector'];
export default APIInterceptorFactory;



// WEBPACK FOOTER //
// ./client/app/common/APIInterceptor/APIInterceptor.factory.js